<template>
    <div v-loading="loading">
        <el-row :gutter="20">
            <el-col class="padding-box" :span="cols">
                <div class="label-span">
                    <span tkey="島嶼名稱">{{i18n.tkey("lang_island_name")}}*</span>
                </div>

                <el-input
                    type="text"
                    v-model="dataForm.recordname"
                    :placeholder="i18n.tkey('lang_island_name')"
                    clearable
                    show-word-limit
                    maxlength="50"
                />
            </el-col>

            <el-col class="padding-box" :span="cols">
                <div class="label-span">
                    <span tkey="島嶼英文名稱">{{i18n.tkey("lang_island_name_en")}}</span>
                </div>

                <el-input
                    type="text"
                    v-model="dataForm.addinfo6"
                    :placeholder="i18n.tkey('lang_island_name_en')"
                    clearable
                    show-word-limit
                    maxlength="50"
                />
            </el-col>

            <el-col class="padding-box" :span="cols">
                <div class="label-span">
                    <span class="label-span" tkey="迎賓圖">{{i18n.tkey("lang_welcome_img")}}</span>&nbsp;(<span tkey="圖片尺寸">{{i18n.tkey("lang_img_size_1")}}</span>&nbsp;<span>800*600</span>)
                </div>

                <UploadImg
                    v-model="dataForm.addinfo11"
                    :sizeLimit="1024"
                    :readonlyTag="readOnlyTag"
                    :useBtn="readOnlyTag !== true"
                    :width="200"
                    :height="150"
                    @deleteImg="dataForm.addinfo11 = 'deleted'"
                />
            </el-col>

            <el-col class="padding-box" :span="cols">
                <div class="label-span">
                    <span class="label-span" tkey="迎賓圖(英文)">{{i18n.tkey("lang_welcome_img_en")}}</span>&nbsp;(<span tkey="圖片尺寸">{{i18n.tkey("lang_img_size_1")}}</span>&nbsp;<span>800*600</span>)
                </div>

                <UploadImg
                    v-model="dataForm.addinfo12"
                    :sizeLimit="1024"
                    :readonlyTag="readOnlyTag"
                    :useBtn="readOnlyTag !== true"
                    :width="200"
                    :height="150"
                    @deleteImg="dataForm.addinfo12 = 'deleted'"
                />
            </el-col>

            <el-col class="padding-box" :span="cols">
                <div class="label-span">
                    <span class="label-span" tkey="介紹圖">{{i18n.tkey("lang_description_img")}}</span>&nbsp;(<span tkey="圖片尺寸">{{i18n.tkey("lang_img_size_1")}}</span>&nbsp;<span>1280*720</span>)
                </div>

                <UploadImg
                    v-model="dataForm.addinfo15"
                    :sizeLimit="1024"
                    :readonlyTag="readOnlyTag"
                    :useBtn="readOnlyTag !== true"
                    :width="256"
                    :height="144"
                    @deleteImg="dataForm.addinfo15 = 'deleted'"
                />
            </el-col>

            <el-col class="padding-box" :span="cols">
                <div class="label-span">
                    <span class="label-span" tkey="介紹圖(英文)">{{i18n.tkey("lang_description_img_en")}}</span>&nbsp;(<span tkey="圖片尺寸">{{i18n.tkey("lang_img_size_1")}}</span>&nbsp;<span>1280*720</span>)
                </div>

                <UploadImg
                    v-model="dataForm.addinfo16"
                    :sizeLimit="1024"
                    :readonlyTag="readOnlyTag"
                    :useBtn="readOnlyTag !== true"
                    :width="256"
                    :height="144"
                    @deleteImg="dataForm.addinfo16 = 'deleted'"
                />
            </el-col>

            <el-col class="padding-box" :span="24">
                <div class="operation-btns">
                    <el-button
                        type="primary"
                        v-if="null == editObj"
                        @click="clickSubmit"
                        tkey="提交"
                    >
                        {{i18n.tkey("lang_submit")}}
                    </el-button>

                    <el-button
                        type="primary"
                        v-if="null != editObj"
                        @click="clickSave"
                        tkey="保存"
                    >
                        {{i18n.tkey("lang_save")}}
                    </el-button>
                </div>
            </el-col>

        </el-row>
    </div>
</template>

<script setup>

import {inject, ref, onBeforeMount, reactive} from "vue";
import myUtil from "@/util/util";
import record14Api from "@/request/record14Api";
import UploadImg from "@/components/shopopee/form/uploadImg.vue";

const props = defineProps(["editObj", "readOnlyTag"])
const emits = defineEmits(["save-complete"])

const i18n = inject("i18n")

const cols = ref(24)
const loading = ref(false)

const dataForm = reactive({
    recordname: "",
    addinfo6: "",
    addinfo11: "",
    addinfo12: "",
    addinfo15: "",
    addinfo16: "",
})

function clickSubmit(){
    addRecord()
}

function clickSave(){
    if (myUtil.isEmpty(dataForm.recordname)){
        myUtil.alertWarning(i18n.tkey("lang_island_name_input_alert"))
        return
    }

    updateRecord()

}

function updateRecord(){
    loading.value = true

    const request = record14Api.updateRecord14
    const param = request.getParams()

    param.id = props.editObj.id
    param.addinfo17 = "-1"
    param.recordname = dataForm.recordname
    param.addinfo6 = dataForm.addinfo6
    param.addinfo11 = dataForm.addinfo11
    param.addinfo12 = dataForm.addinfo12
    param.addinfo15 = dataForm.addinfo15
    param.addinfo16 = dataForm.addinfo16

    request.send(param, (res) => {
        loading.value = false

        if (res.code == 200){
            myUtil.alertSuccess(i18n.tkey("lang_save_success"))
            emits("save-complete")
        }else{
            myUtil.alertError(res.msg)
        }

    })

}

function addRecord(){

}

function fillEditInfo(){
    dataForm.recordname = props.editObj.recordname
    dataForm.addinfo6 = props.editObj.addinfo6
    dataForm.addinfo11 = props.editObj.addinfo11
    dataForm.addinfo12 = props.editObj.addinfo12
    dataForm.addinfo15 = props.editObj.addinfo15
    dataForm.addinfo16 = props.editObj.addinfo16
}

onBeforeMount(() => {
    if (!myUtil.isMobile()){
        cols.value = 12
    }

    if (null != props.editObj){
        fillEditInfo()
    }
})


</script>

<style scoped>

.operation-btns {
    margin-top: 30px;
    text-align: center;
}

.padding-box {
    margin-bottom: 20px;
}

.label-span {
    margin-bottom: 10px;
}

</style>